(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  if (window.innerWidth <= 989) {
    let lastScrollTop = 0;
    let ticking = false;
    const header = document.querySelector('.section-header');

    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > lastScrollTop && scrollTop > 0) {
          // Scrolling down
          header.classList.remove('scrolling-up');
        } else if (scrollTop < lastScrollTop) {
          // Scrolling up
          header.classList.add('scrolling-up');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        ticking = false;
      });
    }, { passive: true });
  }
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // Scroll distance (px) before the header/bar/logo scroll animations fire.
      // Reduced from the full header height so they trigger sooner. "up" < "down"
      // gives a small hysteresis to avoid flicker. The same trigger applies in
      // hover and non-hover (everything is driven by the scrolled-past-header class).
      this.scrollTriggerDown = 24;
      this.scrollTriggerUp = 8;

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.scrollTriggerDown) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.scrollTriggerDown) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.scrollTriggerUp) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  // <shopify-account> expose deux methodes publiques, showModal() et close(),
  // ainsi qu'un shadow root OUVERT.
  //
  // Ouverture : on passe par showModal(), API assumee, plutot que par un clic
  // simule sur le bouton interne. Si elle venait a disparaitre, le gestionnaire
  // ne fait rien et le lien vers la page compte reprend la main.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    const label = event.target.closest('.header__account-label');
    if (!label) return;

    const host = label.closest('.header__account-wrap')?.querySelector('shopify-account');
    if (typeof host?.showModal !== 'function') return;

    event.preventDefault();
    host.showModal();
    showAccountOverlay(host);
  });

  // Connecte, Shopify rend une pastille portant l'initiale du client, que ni
  // slot ni part n'exposent. Le shadow root etant ouvert, on y injecte une
  // feuille qui masque son bouton : c'est notre libelle « Account » qui porte
  // alors l'ouverture.
  //
  // Deconnecte, ce MEME bouton contient le « Log in » slotte et doit rester
  // visible — d'ou le :host() cible sur la classe posee en Liquid.
  //
  // On touche ici a la structure interne d'un composant que Shopify se reserve
  // le droit de faire evoluer. S'il renomme .account-button, la pastille
  // reapparait : c'est visible immediatement, et rien d'autre ne casse.
  const ACCOUNT_SHADOW_CSS = `
    /* Le bouton du composant est masque dans les DEUX etats : le libelle est
       rendu par le theme, hors du shadow DOM, pour suivre exactement le
       traitement de couleur des autres elements du header. */
    .account-button {
      display: none;
    }

    /* Le voile natif est neutralise. Tenter de l'animer etait perdu d'avance :
       a la fermeture le composant retire open, reconstruit son contenu puis pose
       hidden — le ::backdrop est emporte avant toute transition. Le voile est
       donc rendu par le theme (.header__account-overlay), dans le document, ou
       nous en maitrisons le cycle de vie. */
    dialog::backdrop,
    [part='dialog']::backdrop {
      background-color: transparent;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
    }
  `;

  // Feuille CONSTRUCTIBLE plutot qu'une balise <style> appendue : le composant
  // reconstruit son shadow DOM quand l'etat de connexion change, ce qui effacait
  // la balise — et avec elle le masquage du bouton et le voile. Une feuille
  // adoptee vit sur le shadow root, pas dans son arbre, et survit donc a ces
  // reconstructions.
  let accountSheet;

  function getAccountSheet() {
    if (accountSheet !== undefined) return accountSheet;
    try {
      accountSheet = new CSSStyleSheet();
      accountSheet.replaceSync(ACCOUNT_SHADOW_CSS);
    } catch (error) {
      accountSheet = null; // navigateur sans feuilles constructibles
    }
    return accountSheet;
  }

  function applyAccountShadowCss(host) {
    const root = host.shadowRoot;
    if (!root) return false;

    const sheet = getAccountSheet();
    if (sheet && Array.isArray(root.adoptedStyleSheets)) {
      if (!root.adoptedStyleSheets.includes(sheet)) {
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
      }
      return true;
    }

    // Repli : balise <style>, re-appendue par l'observateur si elle disparait.
    if (!root.querySelector('style[data-mobe-account]')) {
      const style = document.createElement('style');
      style.setAttribute('data-mobe-account', '');
      style.textContent = ACCOUNT_SHADOW_CSS;
      root.appendChild(style);
    }
    return true;
  }

  // ---- Voile de la feuille de compte -------------------------------------
  // Le voile est rendu par le theme. Deux declencheurs, pour ne dependre
  // d'aucune etape incertaine : l'evenement « open » du composant (celui-la
  // meme qu'ecoute Dawn pour positionner la feuille) et notre propre appel a
  // showModal(). L'un des deux suffit.
  //
  // La fermeture n'est pas ecoutee : une boucle verifie a chaque image que le
  // dialog est toujours ouvert, quelle que soit la maniere dont le composant
  // s'y prend pour se fermer — retrait d'attribut, hidden, ou demontage. Elle
  // s'arrete d'elle-meme des la fermeture, donc aucun cout au repos, et aucun
  // scenario ne peut laisser le voile colle a l'ecran.

  function getAccountOverlay() {
    let overlay = document.querySelector('.header__account-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'header__account-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  function showAccountOverlay(host) {
    const overlay = getAccountOverlay();

    // Filet pour le tout premier affichage : si l'element vient d'etre insere,
    // il n'a pas encore d'etat de depart peint et la transition serait sautee.
    // Lire offsetWidth force le calcul de style avant le changement de classe.
    void overlay.offsetWidth;

    overlay.classList.add('is-visible');

    const tick = () => {
      const dialog = host.shadowRoot && host.shadowRoot.querySelector('dialog');
      const stillOpen = !!dialog && dialog.isConnected && dialog.hasAttribute('open');
      if (stillOpen) {
        requestAnimationFrame(tick);
        return;
      }
      overlay.classList.remove('is-visible');
    };

    requestAnimationFrame(tick);
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      if (!event.target.matches('shopify-account')) return;
      showAccountOverlay(event.target);
    },
    true
  );

  // Le voile est cree des le chargement, et non a la premiere ouverture : un
  // element insere et rendu visible dans la meme image n'a pas d'etat de depart,
  // et sa premiere transition est sautee. Les suivantes s'animaient bien,
  // puisque l'element existait deja.
  if (document.body) {
    getAccountOverlay();
  } else {
    document.addEventListener('DOMContentLoaded', () => getAccountOverlay());
  }

  function watchAccountShadow(host) {
    if (host.dataset.mobeAccountWatched === 'true') return;
    if (!applyAccountShadowCss(host)) return;

    host.dataset.mobeAccountWatched = 'true';

    new MutationObserver(() => applyAccountShadowCss(host)).observe(host.shadowRoot, {
      childList: true,
      subtree: true,
    });
  }

  // Le shadow root n'existe qu'une fois le composant initialise, et celui-ci
  // peut l'etre tard. On reessaie tant qu'il manque, sur une fenetre large.
  function initAccountShadows(attempt) {
    const hosts = [...document.querySelectorAll('shopify-account')];
    hosts.forEach(watchAccountShadow);

    if (hosts.some((host) => !host.shadowRoot) && (attempt || 0) < 120) {
      requestAnimationFrame(() => initAccountShadows((attempt || 0) + 1));
    }
  }

  if (window.customElements) {
    customElements.whenDefined('shopify-account').then(() => initAccountShadows());
  }
  initAccountShadows();
  document.addEventListener('shopify:section:load', () => initAccountShadows());

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
